﻿package com.milta.core.localization.translations.it

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Il mio profilo",
    sectionPersonal = "Informazioni personali",
    labelFirstName = "Nome",
    labelLastName = "Cognome",
    labelRole = "Ruolo",
    sectionLanguage = "Lingua",
    labelLanguage = "Lingua dell'app",
    changeLanguageButton = "Cambia lingua",
    languageDialogTitle = "Scegli la tua lingua",
    languageDialogConfirm = "Conferma",
    languageDialogCancel = "Annulla",
    sectionPassword = "Sicurezza",
    labelCurrentPassword = "Password attuale",
    labelNewPassword = "Nuova password",
    changePasswordButton = "Cambia password",
    successLanguageUpdated = "Lingua aggiornata con successo",
    successPasswordChanged = "Password cambiata con successo",
    errorProfileNotFound = "Profilo non trovato",
    errorCurrentPasswordRequired = "Inserisci la tua password attuale",
    errorCurrentPasswordTooLong = "La password attuale non può superare i 128 caratteri",
    errorNewPasswordRequired = "Inserisci una nuova password",
    errorNewPasswordTooShort = "La nuova password deve contenere almeno 8 caratteri",
    errorNewPasswordTooLong = "La nuova password non può superare i 128 caratteri",
    errorLanguageRequired = "Seleziona una lingua",
    errorForbidden = "Non sei autorizzato a eseguire questa azione",
    errorValidation = "I dati forniti non sono validi",
    errorGeneric = "Si è verificato un errore. Riprova.",
    signOut = "Disconnettersi",
    deleteAccount = "Elimina account",
    menuLanguage = "Lingua interfaccia",
    menuPassword = "Cambia password",
    menuSubscription = "Il mio abbonamento",
    menuPrivacy = "Privacy & GDPR",
    linkedCodeLabel = "Codice di collegamento unico",
    copyCode = "Copia",
    codeCopied = "Copiato!",
    modeOrganisation = "Azienda",
    modeDriver = "Autista",
    roleDriver = "Autista",
    roleOrganisation = "Azienda",
    modeSwitchTitle = "Cambia modalità",
    modeSwitchHint = "Passa dalla modalità Azienda alla modalità Autista in qualsiasi momento",
    switchToEnterprise = "Modalità Azienda",
    switchToDriver = "Modalità Autista",
    menuPhone = "Numero di telefono",
    phoneOtpStepTitle = "Codice di verifica inviato via SMS",
    successPhoneUpdated = "Numero di telefono aggiornato",
    deleteAccountDialogTitle = "Eliminare il tuo account?",
    deleteAccountDialogMessage = "Questa azione è irreversibile. Le tue informazioni personali verranno eliminate. Un codice di verifica sarà inviato via SMS per confermare.",
    deleteAccountDialogConfirm = "Continua",
    deleteAccountOtpStepTitle = "Codice di verifica inviato via SMS",
    deleteAccountConfirmButton = "Elimina definitivamente",
    errorLastEnterpriseOwner = "Sei l'unico responsabile della tua azienda. Aggiungi un altro account Azienda prima di eliminare il tuo.",
    logoutPendingWarningTitle = "Consegne non inviate",
    logoutPendingWarningMessageSuffix = "consegna/e in attesa andranno perse se esci ora.",
    logoutPendingWarningConfirm = "Esci comunque",
    logoutPendingWarningCancel = "Annulla",
    modeSwitchActiveRouteWarningTitle = "Percorso in corso",
    modeSwitchActiveRouteWarningMessage = "Un percorso è attualmente in corso. Cambiare modalità ti allontanerà dal suo monitoraggio. Continuare?",
    modeSwitchActiveRouteWarningConfirm = "Cambia comunque",
    modeSwitchActiveRouteWarningCancel = "Annulla",
)

